<script setup>
  import { computed } from 'vue';
  import Icon from '@/components/icons/Icon.vue';

  // An edge button for a scroller, shown while there's content past that edge
  // (useScrollAffordance's canScrollStart / canScrollEnd). Its positioned parent holds the
  // scroller; the button sits over the scroller's edge, centered along it.
  const props = defineProps({
    // 'start' (left / top) or 'end' (right / bottom)
    direction: {
      type: String,
      required: true
    },
    // Matches the useScrollAffordance axis: 'horizontal' or 'vertical'
    axis: {
      type: String,
      default: 'horizontal'
    },
    visible: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      required: true
    }
  });

  const emit = defineEmits(['scroll']);

  const iconName = computed(() => {
    if (props.axis === 'vertical') return 'chevron-down';

    return props.direction === 'start' ? 'chevron-left' : 'chevron-right';
  });

  function handleClick() {
    emit('scroll', props.direction);
  }
</script>

<template>
  <Transition name="jwx-scroll-affordance-button">
    <button
      v-if="props.visible"
      @click="handleClick"
      type="button"
      class="jwx-scroll-affordance-button"
      :data-direction="props.direction"
      :data-axis="props.axis"
      :aria-label="props.label"
    >
      <Icon :name="iconName" />
    </button>
  </Transition>
</template>
